"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("@unimaze/api-clients/lib/mapi/api");
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var CommonTranslations_1 = require("../common/components/CommonTranslations");
var ConversionUtility_1 = require("./ConversionUtility");
exports.billingLinesFieldsMetadata = function (formInstance) {
    var billingLinesMetadata = formInstance.getFieldValue(["invoice", "invoiceLines"]);
    return billingLinesMetadata.map(function (billingLine) {
        var cleanBillingLine = ConversionUtility_1.removeEmpty(billingLine);
        var taxableAmount = exports.calculateTaxableAmount(cleanBillingLine.discountValue, cleanBillingLine.quantity, cleanBillingLine.unitPriceAmount);
        var taxPercentage = exports.calculateTaxPercentage(cleanBillingLine.taxCategoryType);
        var taxAmount = exports.calculateTaxAmount(taxableAmount, taxPercentage);
        var mappedBillingLine = __assign({}, cleanBillingLine, { taxableAmount: taxableAmount,
            taxAmount: taxAmount,
            taxPercentage: taxPercentage });
        if (mappedBillingLine.discountValue === "0" || mappedBillingLine.discountValue === "0%") {
            delete mappedBillingLine.discountValue;
        }
        return mappedBillingLine;
    });
};
exports.calculateTaxableAmount = function (discountValue, quantity, unitPriceAmount) {
    if (!quantity || !unitPriceAmount) {
        return 0;
    }
    if (discountValue) {
        if (discountValue.endsWith("%")) {
            // (quantity * unitPriceAmount) * ((100 - discountValue) / 100)
            return ((quantity * unitPriceAmount) * ((100 - parseFloat(discountValue)) / 100));
        }
        else {
            // (quantity * unitPriceAmount) - discountValue
            return ((quantity * unitPriceAmount) - parseFloat(discountValue));
        }
    }
    else {
        return (quantity * unitPriceAmount);
    }
};
exports.calculateTaxAmount = function (taxableAmount, taxPercentage) {
    // taxableAmount * (taxPercentage / 100)
    return (taxableAmount * (taxPercentage / 100));
};
exports.calculateTaxPercentage = function (taxCategoryType) {
    // inferred from the taxCategoryType? what is the mapping? ZeroRated/Exempt = 0, StandardRated = 24, ReducedRate = 11
    switch (taxCategoryType) {
        case api_1.TaxCategoryTypeEnum.StandardRated:
            return 24;
        case api_1.TaxCategoryTypeEnum.ReducedRated:
            return 11;
        case api_1.TaxCategoryTypeEnum.ZeroRated:
        case api_1.TaxCategoryTypeEnum.Exempt:
        case api_1.TaxCategoryTypeEnum.OutsideTaxScope:
            return 0;
        default:
            return 0;
    }
};
exports.generateTaxCategoryLabel = function (taxCategoryType, taxCategoryTypeTranslated) {
    return taxCategoryType ? taxCategoryTypeTranslated + " (" + exports.calculateTaxPercentage(taxCategoryType) + "%)" : "";
};
exports.getCorrectInputNode = function (dataIdx, intl) {
    switch (dataIdx) {
        case "quantity":
        case "unitPriceAmount":
            return react_1.default.createElement(antd_1.InputNumber, { step: 1, style: { width: "100%" } });
        case "unitOfMeasure":
            return (react_1.default.createElement(antd_1.Select, { dropdownMatchSelectWidth: false }, Object.keys(api_1.Units).map(function (unitOfMeasure) {
                if (unitOfMeasure !== "Rec20" && unitOfMeasure !== "Rec21")
                    return (react_1.default.createElement(antd_1.Select.Option, { value: unitOfMeasure, title: unitOfMeasure, key: unitOfMeasure }, intl.formatMessage(CommonTranslations_1.commonTranslationMessages["unitOfMeasure_labels_" + unitOfMeasure])));
            })));
        case "taxCategoryType":
            return (react_1.default.createElement(antd_1.Select, { dropdownMatchSelectWidth: false }, Object.keys(api_1.TaxCategoryTypeEnum).map(function (taxCategoryType) {
                return (react_1.default.createElement(antd_1.Select.Option, { value: taxCategoryType, title: taxCategoryType, key: taxCategoryType }, taxCategoryType));
            })));
        default:
            return react_1.default.createElement(antd_1.Input, null);
    }
};
